export default {
    BUSCAR_PARAMETROS: 'buscarParametrosAction',
    VALIDAR_DOCUMENTO_VIRTUALIZADO: 'validarDocumentoVirtualizado',
    BAIXAR_DOCUMENTOS_VIRTUALIZADOS: 'baixarDocumentosVirtualizados',
    BUSCAR_LICITACOES_PUBLICAS: 'buscarLicitacoesPublicas',
    BUSCAR_DADOS_GERAIS: 'buscarDadosGeraisLicitacao',
    BUSCAR_ANEXOS_EDITAL: 'buscarAnexosEdital',
    BUSCAR_ACOMPANHAMENTO: 'buscarAcompanhamento',
    BUSCAR_ACOMPANHAMENTO_DETALHE: 'buscarAcompanhamentoDetalhe',
    BUSCAR_FORNECEDORES_LOTE: 'buscarFornecedoresLote',
    BUSCAR_DOCUMENTOS_VENCEDOR_LOTE: 'buscarDocumentosVencedorLote',
    BAIXAR_DOCUMENTO_VENCEDOR_LOTE: 'baixarDocumentoVencedorLote',
    BUSCAR_ESCLARECIMENTO_IMPUGNACAO: 'buscarEsclarecimentoImpugnacaoAction',
    BUSCAR_RESPOSTAS_ESCLARECIMENTO_IMPUGNACAO: 'buscarRespostasEsclarecimentoImpugnacao',
    SOLICITAR_ESCLARECIMENTO_IMPUGNACAO: 'solicitarEsclarecimentoImpugnacaoAction',
    BAIXAR_RELATORIO_DA_ATA_DA_LICITACAO: 'baixarRelatorioDaAtaDaLicitacao',
    VALIDAR_CODIGO_EMAIL: 'validarCodigoEmailAction',
    BUSCAR_ESTADOS_EFORNECEDOR: 'buscarEstadosEfornecedor',
    BUSCAR_MUNICIPIOS_POR_ESTADO: 'buscarMunicipiosPorEstado',
    BUSCAR_PROCESSOS_PUBLICADOS: 'buscarProcessosPublicados',
    BUSCAR_PROCESSO_LICITACAO: 'buscarProcessoLicitacao',
    BUSCAR_LOTES_PAGINA_INTERNA: 'buscarLotesPaginaInterna',
    GERAR_XML_PROPOSTA_PRESENCIAL: 'gerarXMLPropostaPresencial',
    BUSCAR_LISTAGEM_SIMULAR_PROPOSTA: 'buscarListagemSimularProposta',
    BUSCAR_IMAGENS_ITEM_BASE64: 'buscarImagensItemBase64',
    BUSCAR_IMAGENS_LOTE_LICITACAO: 'buscarImagensLoteLicitacao',
    FLOWBEE: {
        BAIXAR_ARQUIVO: 'baixarArquivo'
    },
    BUSCAR_DADOS_GERAIS_CREDENCIAMENTO: 'buscarDadosGeraisCredenciamento',
    BUSCAR_ANEXOS_EDITAL_CREDENCIAMENTO: 'buscarAnexosEditalCredenciamento',
    BUSCAR_ESCLARECIMENTO_IMPUGNACAO_CREDENCIAMENTO: 'buscarEsclarecimentoImpugnacaoCredenciamentoAction',
    SOLICITAR_ESCLARECIMENTO_IMPUGNACAO_CREDENCIAMENTO: 'solicitarEsclarecimentoImpugnacaoCredenciamentoAction',
    BUSCAR_RESULTADO_CREDENCIAMENTO_PUBLICO: 'buscarResultadoCredenciamentoPublico',
    BAIXAR_DOCUMENTACAO_FORNECEDOR_CREDENCIAMENTO: 'baixarDocumentacaoFornecedorCredenciamentoPublico',
    BUSCAR_ITENS_LOTES_CREDENCIAMENTO: 'buscarItensLotesCredenciamento',
}
